import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3px;
`

export const Label = styled.label`
  text-align: center;
  color: #FFFFFF;
  margin: 0px;
`
